<template lang="pug">
login-qr-code.qr-login(
  ref='template',
  :moveLinkEvent='moveLinkEvent',
  :errorMessages='errorMessages',
  :useStartCameraButton='true',
  @read-qr-code='readQrCode'
)
  template(#loginTitle) 生徒ログイン
  template(#cameraTitle) カメラに二次元コードをかざしてください
  template(#cameraLoadingText) Loading video...
  template(#startCameraText) 二次元コードでログインする
  template(#moveLinkText) 二次元コードが読み取れない場合はこちら
</template>

<script lang="ts">
import { Component, Mixins, Ref } from 'vue-property-decorator'
import LoginQrCode from '@/components/templates/student/LoginQrCode.vue'
import LoginMethods from '@/mixins/LoginMethods'

/**
 * 二次元コードログイン画面
 */
@Component({
  components: {
    LoginQrCode,
  },
})
export default class QrLogin extends Mixins(LoginMethods) {
  // テンプレートRef
  @Ref() template!: LoginQrCode

  // QRコード読み取り時の処理
  private async readQrCode(qrCodeData: string) {
    this.$loading.start()
    const isLoginSuccess = await this.studentQrLogin(qrCodeData)
    this.$loading.complete()
    // ログイン失敗時、QRコード読み込みカメラ再起動
    if (!isLoginSuccess) setTimeout(() => this.template.startMediaDevice(), 2000)
  }

  /**
   * ログイン後の遷移先ページをオーバーライド
   */
  public topPagePath(): string {
    return '/student/study-selection'
  }

  // 遷移リンク押下時のイベント
  private moveLinkEvent() {
    // 通常ログインページへ
    this.$router.push({ name: 'StudentLogin' })
  }
}
</script>
